package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import kotlinx.coroutines.flow.Flow

class DeleteInspectionReportUseCase(
    private val inspectionRepository: InspectionRepository
) {
    operator fun invoke(
        inspectionId: String
    ): Flow<FlowResult<Unit>> {
        return inspectionRepository.deleteInspectionReport(inspectionId)
    }
}
